module.exports = __webpack_public_path__ + "img/img-3da05a.png";